import React, {FunctionComponent} from 'react';
import './ListSplitter.less';

interface ListSplitterProps {
	isModal?: boolean
	isAlignByContainer?: boolean
}

export const ListSplitter: FunctionComponent<ListSplitterProps> = ({isModal = false, isAlignByContainer}) => {
	return <hr className={`list-splitter ${
		isAlignByContainer ? 'list-splitter--align-by-container' : ''
	} ${
		isModal ? 'list-splitter--modal' : ''
	}`}/>;
};
